<script lang="ts">
	import type { LayerName } from '$lib/components/map/map-styles';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { layerTrackingNames } from '$lib/components/map/map-styles';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import LayerOption from './LayerOption.svelte';

	interface Props {
		selectedLayerName: LayerName;
		onLayerChange: () => void;
	}

	let { selectedLayerName = $bindable(), onLayerChange }: Props = $props();

	const { mapLayerName, mapSettingsUserPreferencesLocalStorage } = getMapLayoutContext();

	function selectLayer(layerName: LayerName) {
		if (selectedLayerName === layerName) {
			return;
		}
		$mapLayerName = layerName;
		selectedLayerName = layerName;
		mapSettingsUserPreferencesLocalStorage.set('mapStyleLayerName', layerName);
		track({
			action: 'layer_selection',
			payload: {
				layer_name: layerTrackingNames[layerName],
				action: 'selection',
			},
		});
		onLayerChange();
	}
</script>

<div class="flex gap-2">
	<LayerOption
		class="w-1/2"
		layer="michelin"
		onclick={() => selectLayer('michelin')}
		selected={selectedLayerName === 'michelin'}
	/>
	<LayerOption
		class="w-1/2"
		layer="scenic"
		onclick={() => selectLayer('scenic')}
		selected={selectedLayerName === 'scenic'}
	/>
</div>
<div class="flex gap-2">
	<LayerOption
		class="w-1/2"
		layer="historic"
		onclick={() => selectLayer('historic')}
		selected={selectedLayerName === 'historic'}
	/>
	<LayerOption
		class="w-1/2"
		layer="hybrid"
		onclick={() => selectLayer('hybrid')}
		selected={selectedLayerName === 'hybrid'}
	/>
</div>
